import React, { Component } from 'react';
import Player from '@vimeo/player';
import Navigation from '../../UI/Navigation/Navigation';
import Question from '../../Question/Question';
import Backdrop from '../../UI/Backdrop/Backdrop';
import Valuation from '../../Valuation/Valuation';
import HowTo from '../../../container/HowTo/HowTo';

import classes from './LearningVideo.module.css';
import videoDataList from '../../../assets/json/data.json';

class LearningVideo extends Component {
    state = {
        start: 0,
        pause: false,
        chapters: null,
        currentChapter: 1,
        userTimeChange: false,
        showQuestion: false,
        openModal: false,
        valuateType: false,
        valuateShow: false,
        fullscreen: false,
    }

    player;
    videoID;
    questions;
    currentQuestion;

    componentDidMount() {
        let videoSlug = this.props.location.pathname.substring(1, this.props.location.pathname.length); // video Slug basierend auf pathname

        this.parseVideoDataList(videoSlug);

        if (this.videoID) {
            this.buildVimeoPlayer();
        }
    }

    buildVimeoPlayer = () => {
        console.log(this.videoID);
        let self = this;

        let options = {
            id: this.videoID,
            playsinline: false,
        }

        self.player = new Player('vimeo', options);

        self.player.on('fullscreenchange', (data) => {
            self.setState({ fullscreen: data.fullscreen });
        });

        self.player.on('pause', (data) => {
            var cancelFullScreen = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;

            if (self.state.fullscreen) {
                if (document.exitFullscreen)
                    document.exitFullscreen();
                else if (document.webkitExitFullscreen)
                    document.webkitExitFullscreen();
                else if (document.mozCancelFullScreen)
                    document.mozCancelFullScreen();
                else if (document.msExitFullscreen)
                    document.msExitFullscreen();
            }
        });

        /**
         * Kapitel des Players werden ausgelesen und in state eingepflegt.
         */
        self.player.getChapters().then(function (chapters) {
            self.setState({ chapters: chapters });
        }).catch(function (error) {
            console.log(error);
        });

        // Leitet zur Startseite weiter sobald das Video beendet wurde.
        self.player.on('ended', function (data) {
            self.props.history.push("/");
        });

        /**
         * Event Listener für das Ändern der Kapitel
         */
        self.player.on('chapterchange', function (data) {

            if (!self.state.userTimeChange) {
                self.setState({ currentChapter: data.index });
            }
            if (self.checkIfChapterHasQuestion(data.index) && !self.state.userTimeChange) {
                self.player.pause();
                self.getQuestionofChapter(data.index);

            }

            self.setState({
                userTimeChange: false,
            });


        });
    }
    valuateAnswer = (answerID) => {
        let type = false;
        if (answerID === this.currentQuestion.correctAnswer) {
            // console.log("Richtige Antwort");
            type = true;

        }
        this.setState(prevState => {
            return {
                showQuestion: prevState.showQuestion = false,
                valuateShow: prevState.valuateShow = true,
                valuateType: prevState.valuateType = type
            };
        });
    }

    checkIfChapterHasQuestion = (chapterIndex) => {
        // console.log(chapterIndex);
        let questionChapterIndex = chapterIndex - 1; //  Fragen werden erst angezeigt wenn das nächste Kapitel beginnt.
        let state = false;
        for (let question of this.questions) {
            if (question.chapterIndex === questionChapterIndex) {
                state = true;
            }
        }
        return state;
    }

    getQuestionofChapter(index) {
        index = index - 1; // weil die Frage zum vorherigen Kapitel gehört.
        for (let question of this.questions) {
            if (index === question.chapterIndex) {
                this.currentQuestion = question;
                this.setState({
                    showQuestion: true,
                    openModal: true
                });

            }
        }
        // console.log(this.currentQuestion);
    }

    parseVideoDataList = (slug) => {
        for (let videoData of videoDataList.data) {
            if (videoData.slug === slug) {

                videoData = videoData.data;
                if (videoData && videoData.videoID) {

                    this.videoID = videoData.videoID;
                }
                if (videoData && videoData.questions) {
                    this.questions = videoData.questions;
                }
            }
        }
    }

    getChapterAfterValuation = (chapterIndex, previous = false, solving = false) => {
        let self = this;

        if (chapterIndex && chapterIndex !== this.state.currentChapter) {

            let chapterStartTime;

            for (let chapter of this.state.chapters) {
                if (chapter.index === chapterIndex) {
                    chapterStartTime = chapter.startTime;
                }
            }
            
            if (previous && this.currentQuestion.jump) {
                chapterStartTime = this.currentQuestion.jump; // Um zu einem benutzerdefinierten Zeitpunkt zu springen.
            }
            // Bei dem Wiederholen einer Lektion wird ein geringer Wert addiert, um nicht auf dem Breakpoint des Kapitels zu landen
            // Das sorgt dafür, dass die Frage nicht auftaucht.
            else if (previous) chapterStartTime = chapterStartTime + 0.00001;

            this.player.setCurrentTime(chapterStartTime).then(function (seconds) {
                self.player.pause();
            });

            this.setState({
                userTimeChange: true,
                currentChapter: chapterIndex
            });
        }

        this.setState({
            valuateShow: false,
            openModal: false,
            userTimeChange: !solving, // Bei Situation auflösen wird der utc auf true gesetzt
        });

        // // Falls Fullscreenstate vorher true war.
        // if (this.state.wasFullScreen) {
        //     this.player.requestFullscreen();
        //     this.setState({ wasFullScreen: false });
        // }

        this.player.play();

    }
    /**
     * Springt zu dem gewünschten Kapitel (Modulübersicht)
     * @param {string} time 
     */
    navigateChapter = (time) => {
        let self = this;
        // Direktes schreiben von userTimeChange um bei den asynchronen Funktionen nicht für ungewolltes Überschneiden zu sorgen.

        self.setState({
            userTimeChange: true
        });

        self.player.setCurrentTime(time).then(function (seconds) {
            let indexOfChapter = 1; // default value

            for (let chapter of self.state.chapters) {
                if (parseInt(time) === chapter.startTime) {
                    indexOfChapter = chapter.index
                    //console.log(indexOfChapter);
                }
            }
            if (self.checkIfChapterHasQuestion(indexOfChapter)) {
                self.getQuestionofChapter(indexOfChapter);
            }
            self.setState({
                currentChapter: indexOfChapter,
            });

            self.player.pause();
        });

    }

    render() {
        let navigation = this.state.chapters ?
            <Navigation chapters={this.state.chapters} currentChapter={this.state.currentChapter}
                click={this.navigateChapter} /> : null;
        let backdrop = this.state.openModal ? <Backdrop /> : null;
        let question = this.state.showQuestion ? <Question data={this.currentQuestion} clickValuate={this.valuateAnswer} /> : null;
        let valuation = this.state.valuateShow ? <Valuation type={this.state.valuateType} chapters={this.state.chapters} current={this.state.currentChapter} click={this.getChapterAfterValuation} self={this} /> : null;

        return (
            <>
                <HowTo vimeoPlayer={this.player} />

                {navigation}
                <div id="vimeo" className={classes.Vimeo}></div>
                {backdrop}
                {question}
                {valuation}

            </>
        );
    }
}

export default LearningVideo;